// What a bill's state is called on screen — ONE list, for the patient's own
// Account and a guardian's view of a dependent's (memberships audit C37).
//
// The server's contract names the states (blhWebServer
// `domain/receivables/patientBillingContract.js`); change the two together. A
// state this list does not know yet is shown under a neutral label — it never
// blanks the statement, as a strict schema once did on "no_charge".

export type StatePillVariant =
  | "outstanding"
  | "partial"
  | "paid"
  | "covered_insurance"
  | "covered_membership"
  | "insurance_pending"
  | "no_charge"
  | "returned";

export const BILLING_STATE_PILL: Record<string, { variant: StatePillVariant; label: string }> = {
  outstanding: { variant: "outstanding", label: "Outstanding" },
  partial: { variant: "partial", label: "Partial" },
  paid: { variant: "paid", label: "Paid" },
  covered_by_insurance: { variant: "covered_insurance", label: "Covered by insurance" },
  covered_by_membership: { variant: "covered_membership", label: "Covered by membership" },
  insurance_pending: { variant: "insurance_pending", label: "Awaiting insurance" },
  no_charge: { variant: "no_charge", label: "No charge" },
  returned: { variant: "returned", label: "Returned" },
};

/** The pill for a state; a state not known yet reads "Updated". */
export function billingStatePill(state: string): { variant: StatePillVariant | "neutral"; label: string } {
  return BILLING_STATE_PILL[state] || { variant: "neutral", label: "Updated" };
}
